import React from 'react';
import MediaRouteHeaderTitle from '@/components/Navigation/Routes/MediaRouteHeaderTitle';

const VideosRouteNavigationOptions = {
  title: 'Videos',
  headerTitle: () => (
    <MediaRouteHeaderTitle
      loggedInKey="navigation.videos"
      loggedOutKey="navigation.createVideos"
      fallback="Videos"
    />
  ),
  headerBackVisible: false,
};

export default VideosRouteNavigationOptions;
